import microApp from '@micro-zoe/micro-app';

function completeUrl(url: string) {
  if (!url.startsWith('//')) return url;

  try {
    return new URL(url, location.origin).href;
  } catch (ex) {
    console.error(ex);
    return url;
  }
}

// 缓存已经预加载过的子应用
const fetchedApps: { [index: string]: boolean } = {};

function preFetch(apps: { name: string; url: string }[]) {
  const appsNeedPreFetch = apps
    .filter((item) => {
      return !fetchedApps[item.name];
    })
    .map((item) => {
      return { ...item, url: completeUrl(item.url) };
    });
  microApp.preFetch(appsNeedPreFetch);

  appsNeedPreFetch.forEach((item) => {
    fetchedApps[item.name] = true;
  });
}

export default preFetch;
